import React from "react";
import { Link, useNavigate } from "react-router-dom"
import { Button } from '@material-ui/core'

function LecturerNav() {

    const currentUser = localStorage.getItem("firstName") + " " + localStorage.getItem("secondName") || "user"
    const navigate = useNavigate();

    const logout = () => {
        localStorage.clear();
        navigate('/login');
    }

    return (
        <div className="navigationContainer">
            <nav>
                <Link to='/lecturerHomepage' className="navLink">
                    <p>Home</p>
                </Link>
                <Link to='/lecturerViewProjects' className="navLink">
                    <p>Projects</p>
                </Link>
                <Link to='/lecturerCreateEditProject' className="navLink">
                    <p>Create/Edit Projects</p>
                </Link>
                <Link to='/lecturerEditInfo' className="navLink">
                    <p>Edit Info</p>
                </Link>
                <Link to='/lecturerViewFinalAllocation' className="navLink">
                    <p>Final Allocations</p>
                </Link>
                {currentUser ? (
                    <div className="navOptions">
                        <p>{currentUser}</p>
                        <Button onClick={logout}><p className="buttontext">Logout</p></Button>
                    </div>
                ) : (
                    <Link to="/login">
                    <button type="button">
                        Sign in
                    </button>
                </Link>
                )}
            </nav>
        </div>
    ) 
}

export default LecturerNav;